import { Component, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { LearningHubService } from '../../services/learning-hub.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { getCourseType } from '../../../profile/queries/course.query';
import { CourseSectionService } from 'src/app/modules/profile/services/course-section.service';
import { DatePipe } from '@angular/common';
import { BannersInfoTabService } from 'src/app/modules/dashboard/modules/banners/services/banners-info-tab-service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from 'src/app/core/services/login.service';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';


@Component({
  selector: 'app-learning-hub',
  templateUrl: './learning-hub.component.html',
  styleUrls: ['./learning-hub.component.scss']
})
export class LearningHubComponent implements OnInit {


  limit = 10;
  offset = 0;
  loading = false;
  endOfData = false;
  learingHubList: any[] = [];
  currentSearch = '';
  filters: any = {};
  searchTerm$ = new Subject<string>();
  locationTerm$ = new Subject<string>();
  private lastSearchApplied = '';
  private lastLocationApplied = '';
  private lastAppliedDate: string | null = null;
  getEventype: string[] = [];
  getCatagoryType: any[] = [];
  communityNames: any;

  showSharePopup = false;
  shareType: string = 'LEARNHUB';
  shareData: any;
  dataLoader = false;
   communityIds: string[] = [];

  constructor( private Commonservice:CommonServicesForAllModules,private spinner: NgxSpinnerService, private LearningHubService: LearningHubService, private CourseSectionService: CourseSectionService, private datePipe: DatePipe, private bannersInfoTabService: BannersInfoTabService,private loginService: LoginService,
   
  ) { }


  @ViewChildren('bannerSlide') bannerSlideRefs!: QueryList<ElementRef>;
  bannerObservers: IntersectionObserver[] = [];
  viewedBannerIds: Set<number> = new Set();

  @ViewChildren('listViewSlide') listViewBNSlideRefs!: QueryList<ElementRef>;
  listViewBNObservers: IntersectionObserver[] = [];
  listviewedBNIds: Set<number>[] = [];

  bannerList: any;
  categoryList: any;
  filteredBannerList: any[] = [];
  headerSlides: any[] = [];
  headerTimer: number = 1000;
  loginDetgails : any

  listViewBannerData: any[] = [];
  listViewTimer: number = 1000;

  ngOnInit(): void {

    this.loginDetgails = this.loginService.getLoginData()
    this.getMyCommunity();
    this.spinner.show();
    this.getEventType();
    this.getCatagory();
    this.searchTerm$.pipe(
      debounceTime(600),
      distinctUntilChanged()
    ).subscribe(term => {
      const trimmed = (term ?? '').trim();
      if (trimmed === '' && term !== '') return;
      if (trimmed !== this.lastSearchApplied) {
        this.lastSearchApplied = trimmed;
        this.applyFilters();
      }

    });
    this.locationTerm$.pipe(
      debounceTime(600),
      distinctUntilChanged()
    ).subscribe(location => {
      const trimmedLoc = (location ?? '').trim();
      if (trimmedLoc === '' && location !== '') return;
      if (trimmedLoc !== this.lastLocationApplied) {
        this.lastLocationApplied = trimmedLoc;
        this.applyFilters();
      }
    });

    // this.getLearningHubData();
    this.getBannersCategory();
    this.getFilteredBanners();
  }


  ngAfterViewInit() {
    this.observeBannerSlides();
    this.listViewBNSlides();

    this.bannerSlideRefs.changes.subscribe(() => {
      this.observeBannerSlides();
    });

    this.listViewBNSlideRefs.changes.subscribe(() => {
      this.listViewBNSlides();
    });

  }

  onSearch(term: string): void {
    this.searchTerm$.next(term);
  }

  onLocationChange(location: string): void {
    this.locationTerm$.next(location);
  }

  onDateChange(date: Date | null) {
    const formattedDate = date
      ? this.datePipe.transform(date, 'yyyy-MM-dd')
      : null;

    if (formattedDate !== this.lastAppliedDate) {
      this.selectedDate = formattedDate;
      this.lastAppliedDate = formattedDate;
      this.applyFilters();
    }
  }

  onDateCleared(event: Event) {
    const input = (event.target as HTMLInputElement).value.trim();

    if (!input && this.lastAppliedDate !== null) {
      this.selectedDate = null;
      this.lastAppliedDate = null;
      this.applyFilters();
    }
  }

     
  getMyCommunity() {
    
  this.Commonservice.getMyCommunityData(this.loginDetgails.id).subscribe((data: any[]) => {
    this.communityNames = data;
    this.communityIds = data.map(c => c.community_id); 


    this.getLearningHubData();
    
  });
}


  getLearningHubData(): void {
    if (this.loading || this.endOfData) return;

    const loginId = this.loginDetgails.id
    const JoinCommunityIds= this.communityIds;


    this.loading = true;
    this.LearningHubService.getAllLearningHubData(
      this.limit,
      this.offset,
      this.currentSearch,
      this.filters,
      JoinCommunityIds,
      loginId
    ).subscribe(data => {
      const newData = data || [];
      if (newData.length < this.limit) {
        this.endOfData = true;
      }
      this.learingHubList = [...this.learingHubList, ...newData];

      this.offset += this.limit;
      this.loading = false;
      this.dataLoader = false;
      this.spinner.hide();
    }, () => {
      this.loading = false;
      this.spinner.hide();
    });
  }
  getSeatStatus(course: any): { type: 'sold' | 'hurry' | 'fill', remaining: number } {
    const remaining = course.number_of_seats - course.course_registered_users_aggregate.aggregate.count;

    if (remaining <= 0) {
      return { type: 'sold', remaining: 0 };
    } else if (remaining <= 10) {
      return { type: 'hurry', remaining };
    } else {
      return { type: 'fill', remaining };
    }
  }




  getEventType(): void {
    this.CourseSectionService.getCourseType().subscribe(res => {
      this.getEventype = (res || []).map((item: any) => item.name);
    });
  }

  getCatagory(): void {
    this.CourseSectionService.getCourseCategories().subscribe(res => {
      this.getCatagoryType = (res || []);
    })
  }

  // Add selected arrays
  selectedTypes: string[] = [];
  selectedCategoryIds: string[] = [];
  selectedDate: string | null = null;
  selectedLocation: string = '';
  selectedCommunities: string[] = [];


  // When a type checkbox changes
  onTypeChange(typeName: string, checked: boolean) {
    if (checked) {
      this.selectedTypes.push(typeName);
    } else {
      this.selectedTypes = this.selectedTypes.filter(t => t !== typeName);
    }
    this.applyFilters();
  }

  // When a category checkbox changes
  onCategoryChange(catId: string, checked: boolean) {
    if (checked) {
      this.selectedCategoryIds.push(catId);
    } else {
      this.selectedCategoryIds = this.selectedCategoryIds.filter(c => c !== catId);
    }
    this.applyFilters();
  }

   onCommunityChange(CommunityId: string, checked: boolean) {
    if (checked) {
      this.selectedCommunities.push(CommunityId);
    } else {
      this.selectedCommunities = this.selectedCommunities.filter(t => t !== CommunityId);
    }
    this.applyFilters();
  }


  applyFilters() {
    this.filters = {
      type: this.selectedTypes,
      categoryIds: this.selectedCategoryIds,
      start_date: this.selectedDate,
      address: this.selectedLocation,
      communities : this.selectedCommunities,
      JoinCommunityIds: this.communityIds
    };
    this.offset = 0;
    this.learingHubList = [];
    this.endOfData = false;
    this.dataLoader = true;
    this.getLearningHubData();
  }


  onClear(): void {
    const hasFilters =
      this.currentSearch.trim() !== '' ||
      this.selectedLocation.trim() !== '' ||
      this.selectedTypes.length > 0 ||
      this.selectedCategoryIds.length > 0 ||
      this.selectedCommunities.length > 0 ||
      this.selectedDate !== null;

    if (!hasFilters) {
      return;
    }

    this.currentSearch = '';
    this.selectedLocation = '';
    this.selectedTypes = [];
    this.selectedCategoryIds = [];
    this.selectedCommunities =[];
    this.selectedDate = null;
    this.filters = {};
    this.offset = 0;
    this.learingHubList = [];
    this.endOfData = false;

    this.applyFilters();
  }






  trackBycourseId(index: number, courseId: any) {
    return courseId.id;
  }


  //  Avertisement banner:
  getFilteredBanners(): void {
    const filters = {
      status: 'APPROVED',
      category_names: ['All Header Banners', 'All List View Large Banners'],
      banner_location: [
        'Web Header Learning-hub', 'Website Learning-hub List View'
      ],
    };

    this.bannersInfoTabService.getFilteredBannersData(filters).subscribe({
      next: (data) => {
        this.bannerList = data;
        this.filterBannersByCategory();
      },
    });
  }

  getBannersCategory() {

    this.bannersInfoTabService.getBannersCategoryDatas().subscribe(data => {
      this.categoryList = data;

      const FindheaderTimer = data.find(category =>
        category?.name === 'All Header Banners'
      )?.timer

      // find Listview Timer
      const FindListViewTimer = data.find(category =>
        category?.name === 'All List View Large Banners'
      )?.timer

      this.updateHeaderTimer(FindheaderTimer);
      this.UpdateListTimer(FindListViewTimer);

      // After categories loaded, filter

    });

  }

  // Update Header Timer
  updateHeaderTimer(newDelay: number): void {
    this.headerTimer = Number(newDelay) * 1000;

    this.headerbannerSwiperConfig = {
      ...this.headerbannerSwiperConfig,
      autoplay: {
        delay: this.headerTimer,
        disableOnInteraction: false,
      },
    };
  }

  // Update List view Timer
  UpdateListTimer(newDelay: number): void {
    this.listViewTimer = Number(newDelay) * 1000;

    this.listViewBNSwiperConfig = {
      ...this.listViewBNSwiperConfig,
      autoplay: {
        delay: this.listViewTimer,
        disableOnInteraction: false,
      },
    };
  }

  filterBannersByCategory() {

    if (!this.bannerList) return;


    // Filter Header job seek ocation -Website Header Banner
    const today = new Date().toISOString().split("T")[0] + "T00:00:00+00:00";

    const FilterHeader = this.bannerList.filter(
      banner =>
        banner?.category_name === 'All Header Banners' && banner.schedule_date <= today
    );

    // Choose Admin or non-Admin banners based on existence
    const isAdminExist = FilterHeader.some(b => b.company_name === 'ADMIN');

    const FilterHeaderData = FilterHeader.filter(banner =>
      isAdminExist ? banner.company_name === 'ADMIN' : banner.company_name !== 'ADMIN'
    );


    this.headerSlides = [];
    FilterHeaderData.forEach(banner => {
      banner.image?.forEach(img => {
        this.headerSlides.push({
          img,
          id: banner.id,
          url: banner.url,
          category_name: banner.category_name,
          views: banner.views,
          banner_name: banner.banner_name

        });
      });
    });

    // Filter List View Banner
    const FilterlistViewBanner = this.bannerList.filter(
      banner =>
        banner?.category_name === 'All List View Large Banners' && banner.schedule_date <= today
    );

    // Choose Admin or non-Admin banners based on existence
    const isAdminExistList = FilterlistViewBanner.some(b => b.company_name === 'ADMIN');

    const FilterlistViewBannerData = FilterlistViewBanner.filter(banner =>
      isAdminExistList ? banner.company_name === 'ADMIN' : banner.company_name !== 'ADMIN'
    );

    this.listViewBannerData = [];
    FilterlistViewBannerData.forEach(banner => {
      banner.image?.forEach(img => {
        this.listViewBannerData.push({
          img,
          id: banner.id,
          url: banner.url,
          category_name: banner.category_name,
          views: banner.views,
          banner_name: banner.banner_name

        });
      });
    });





  }



  listViewRandomSwiperConfig(i: number) {
    const config = { ...this.listViewDynamicSwiperConfig() };
    config.initialSlide = Math.floor(i / 2) % this.listViewBannerData.length;
    return config;
  }

  // Banner 
  listViewDynamicSwiperConfig(): SwiperConfigInterface {
    // Always return a new object to avoid shared state
    return { ...this.listViewBNSwiperConfig };
  }




  public headerbannerSwiperConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: this.headerTimer,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: true,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    pagination: true,

    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
  }


  public listViewBNSwiperConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: this.listViewTimer,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: true,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    pagination: true,

    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
  }



  private observeBannerSlides() {
    // Disconnect previous observers
    this.bannerObservers.forEach(observer => observer.disconnect());
    this.bannerObservers = [];

    if (!this.bannerSlideRefs) return;

    this.bannerSlideRefs.forEach((slideRef: ElementRef, index: number) => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const headerBanner = this.headerSlides[index];

            if (headerBanner && !this.viewedBannerIds.has(headerBanner.id)) {

              headerBanner.views = (headerBanner.views) + 1;
              this.viewedBannerIds.add(headerBanner.id);
              const viewscount = { views: headerBanner.views };

              this.bannersInfoTabService.updateBanner(headerBanner.id, viewscount).subscribe();
            }

          }
        });
      }, { threshold: 0.5 }); // 50% visible
      observer.observe(slideRef.nativeElement);
      this.bannerObservers.push(observer);
    });
  }


  // listview Update views
  private listViewBNSlides() {
    // Clear previous tracking
    this.listviewedBNIds = [];

    const allSlides = this.listViewBNSlideRefs.toArray();
    const bannersPerSwiper = 1; // each swiper is injected every 5 items (update if needed)

    let swiperIndex = -1;
    for (let i = 0; i < allSlides.length; i++) {
      if (i % this.listViewBannerData.length === 0) {
        swiperIndex++;
        this.listviewedBNIds[swiperIndex] = new Set<number>();
      }

      this.observeListViewSingleBanner(
        allSlides[i],
        this.listViewBannerData[i % this.listViewBannerData.length],
        this.listviewedBNIds[swiperIndex],
        swiperIndex
      );
    }
  }

  private observeListViewSingleBanner(
    slideRef: ElementRef,
    banner: any,
    viewedIds: Set<number>,
    swiperIndex: number
  ) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (banner && !viewedIds.has(banner.id)) {
            banner.views = (banner.views || 0) + 1;
            viewedIds.add(banner.id);

            const viewscount = { views: banner.views };
            this.bannersInfoTabService.updateBanner(banner.id, viewscount).subscribe();

          }
        }
      });
    }, { threshold: 0.5 });

    observer.observe(slideRef.nativeElement);
    this.listViewBNObservers.push(observer);
  }

  // card banner -swiper 

  // banner
  bannerSwiperConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true }, //
    speed: 200,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    loop: true,
  };


  shareCourse(data: any, event: Event) {
    event.stopPropagation(); // prevent parent click

    this.shareType = 'LEARNHUB';
    this.shareData = data;
    this.showSharePopup = true;
  }


    prsentersConfig: SwiperConfigInterface = {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
    fadeEffect: { crossFade: true }, 
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
      },
      speed: 1000,
      spaceBetween: 10,
    };

}
